import { MealTime } from "@/clients/models/MealTime";

/**
 * Formats a MealTime enum value into a human-readable string
 * @param time - The meal time enum value
 * @returns Formatted meal time string (e.g., "Breakfast", "Lunch", "Dinner", "Snacks")
 */
export const formatMealTime = (time: MealTime): string => {
  switch (time) {
    case MealTime.BREAKFAST:
      return "Breakfast";
    case MealTime.LUNCH:
      return "Lunch";
    case MealTime.DINNER:
      return "Dinner";
    case MealTime.SNACK:
      return "Snacks";
    default:
      return "";
  }
};
